import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import isHotKey from 'is-hotkey';
import PropTypes from 'prop-types';
import { DeleteIcon } from '../../../../Icons';
import Tag from './Tag';
import PopoverOnClick from '../../../../PopoverOnClick';
import Popover from '../../../../Popover';
import { getAllColors, getColorClassName } from '../utils/colors';
import { DATABASE_EDIT_TAG_COLOR } from '../../../../../types/AnalyticsTypes';

var DatabaseSelectTagForm =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseSelectTagForm, _React$PureComponent);

  function DatabaseSelectTagForm(props, context) {
    var _this;

    _classCallCheck(this, DatabaseSelectTagForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatabaseSelectTagForm).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onClickDelete", function (event) {
      event.stopPropagation();
      event.preventDefault();

      _this.props.database.removeSelectOption(_this.props.column.key, _this.props.option);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      event.stopPropagation();

      if (isHotKey('enter', event) || isHotKey('escape', event) || isHotKey('tab', event)) {
        event.preventDefault();

        _this.onSaveTitle();

        _this.titleRef.current.blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveTitle", function () {
      var value = _this.titleRef.current.value;

      _this.props.database.updateSelectOption(_this.props.column.key, _objectSpread({}, _this.props.option, {
        label: value
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveColor", function (_ref) {
      var bgColor = _ref.bgColor,
          textColor = _ref.textColor;

      _this.props.database.updateSelectOption(_this.props.column.key, _objectSpread({}, _this.props.option, {
        bgColor: bgColor,
        textColor: textColor
      })).command('track', DATABASE_EDIT_TAG_COLOR);
    });

    _defineProperty(_assertThisInitialized(_this), "renderColorForm", function (_ref2) {
      var closePopover = _ref2.closePopover;
      return React.createElement(Popover, {
        className: "slite-editor-database-popover"
      }, React.createElement("div", {
        className: "flexbox padding-normal"
      }, Object.values(getAllColors()).map(function (_ref3) {
        var bgColor = _ref3.bgColor,
            textColor = _ref3.textColor;
        return React.createElement("div", {
          key: bgColor,
          onClick: function onClick(event) {
            event.stopPropagation();
            event.preventDefault();
            closePopover();

            _this.onSaveColor({
              bgColor: bgColor,
              textColor: textColor
            });
          },
          className: classNames('flexbox-no-shrink', 'pointer', 'padding-smaller margin-right-small radius-normal')
        }, React.createElement("div", {
          key: bgColor,
          className: classNames('radius-round', getColorClassName({
            bgColor: bgColor
          })),
          style: {
            width: 16,
            height: 16
          }
        }));
      })));
    });

    _this.titleRef = React.createRef();
    return _this;
  }

  _createClass(DatabaseSelectTagForm, [{
    key: "render",
    value: function render() {
      var option = this.props.option;
      return React.createElement("div", {
        key: option.label,
        className: "flexbox flexbox-wrap margin-bottom-small font-size-normal"
      }, React.createElement(PopoverOnClick, {
        position: "bottom",
        align: "start",
        containerStyle: {
          zIndex: 30 // Needs to be above 25, fixed base z-index

        },
        content: this.renderColorForm
      }, React.createElement("div", {
        className: classNames('flexbox-no-shrink', 'pointer opacity-normal-on-hover', 'margin-vertical-smaller margin-right-small radius-round', getColorClassName({
          bgColor: option.bgColor
        })),
        style: {
          width: 18,
          height: 18
        }
      })), React.createElement("div", {
        className: "flexbox-grow font-weight-medium line-height-large",
        style: {
          flexBasis: '33%'
        }
      }, React.createElement(Tag, {
        preventRemoval: true,
        option: _objectSpread({}, option, {
          label: React.createElement("input", {
            ref: this.titleRef,
            style: {
              background: 'none',
              color: 'inherit',
              border: 'none',
              width: '100%',
              minWidth: 0
            },
            autoFocus: option.label.length === 0,
            onBlur: this.onSaveTitle,
            onKeyDown: this.onKeyDown,
            className: "font-size-normal padding-vertical-smaller shade-10 font-weight-medium",
            type: "text",
            defaultValue: option.label
          })
        })
      })), React.createElement("div", {
        className: "flexbox-no-shrink margin-left-small pointer shade-30 shade-20-on-hover",
        onClick: this.onClickDelete
      }, React.createElement(DeleteIcon, {
        style: {
          verticalAlign: -5
        },
        size: 14
      })));
    }
  }]);

  return DatabaseSelectTagForm;
}(React.PureComponent);

_defineProperty(DatabaseSelectTagForm, "propTypes", {
  database: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired
});

export default DatabaseSelectTagForm;